import { UpdateContractRequestMutationInterface } from '@vendasta/billing';

export const setNetD = (netD: number): UpdateContractRequestMutationInterface => ({ netD });
export const setCurrencyCode = (currencyCode: string): UpdateContractRequestMutationInterface => ({ currencyCode });
export const setStatus = (status: string): UpdateContractRequestMutationInterface => ({ status });
export const setDimension = (dimension: string): UpdateContractRequestMutationInterface => ({ dimension });
export const setSigned = (signed: Date): UpdateContractRequestMutationInterface => ({ signed });
export const setActivated = (activated: Date): UpdateContractRequestMutationInterface => ({ activated });
export const setEnd = (end: Date): UpdateContractRequestMutationInterface => ({ end });
export const setModified = (modified: Date): UpdateContractRequestMutationInterface => ({ modified });
export const setCreditLimit = (creditLimit: number): UpdateContractRequestMutationInterface => ({ creditLimit });
export const setSubscriptionId = (subscriptionId: string): UpdateContractRequestMutationInterface => ({
  subscriptionId,
});
